( function () {
   
    'use strict';

    ( function ( $ ) {
        // $(".match-day-tab-list").click(function () {
        //     if ($(this).hasClass('active')) {
        //     } else {
        //       var tabid = $(this).attr('id');
        //       $(".match-day-tab-list").removeClass('active');
        //       $(this).addClass('active');
        //       $(".match-day-tab-list-content").removeClass('active');
        //       $("#" + tabid + "-content").addClass("active");
        //     }
        //     return false;
        // });

        // $('.match-day-tab-content-top').click(function(j) {
        //   var dropDown = $(this).closest('.match-day-detail-box').find('.match-day-text-btn');
        //   $(this).closest('.match-day-detail-half').find('.match-day-text-btn').not(dropDown).slideUp();
        //   $('.match-day-detail-box.openbg').removeClass('openbg');
        //   if ($(this).hasClass('open')) {
        //     $(this).removeClass('open');
        //   } else {
        //     $(this).closest('.match-day-detail-half').find('.match-day-tab-content-top.open').removeClass('open');
        //     $(this).addClass('open');
        //     $(this).parent().addClass('openbg');
        //   }
        //   dropDown.stop(false, true).slideToggle();
        //   j.preventDefault();
        // });
       
        
    } )( jQuery );
} )();

